import moment from 'moment';
import 'moment/locale/de';

export function getMessage(lecture) {
  moment.locale('de');

  return encodeURIComponent([
    'Hallo Frau Dr. Fritsche,',
    `Ich interessiere mich für das von Ihnen angebotene Seminar "${lecture.title}" am ${moment(lecture.date).format('Do MMMM')}.\nBitte schicken Sie mir unverbindlich einen Teilnahmebogen zu.`,
    'Mit freundlichen Grüßen,',
  ].join('\n\n'));
}

export function getRequestMessage(lecture) {
  return encodeURIComponent([
    'Hallo Frau Dr. Fritsche,',
    `Ich interessiere mich für das von Ihnen angebotene Seminar "${lecture.title}".\nBitte informieren sie mich unter dieser eMail Adresse, sobald wieder ein Termin feststeht.`,
    'Mit freundlichen Grüßen,',
  ].join('\n\n'));
}



// WEBPACK FOOTER //
// ./src/components/lecture/utils/get-message.js